import Api from "../Utils/Axios";

export const GetWelfareList = async (searchValue = "") => {
  const response = await Api.get(`welfare/list?search=${searchValue?.search}`);
  return response.data;
};

export const CreateWelfare = async (data) => {
  const response = await Api.post('welfare/',data);
  return response.data;
};

export const GetSingleWelfare = async ({ id }) => {
  const response = await Api.get(`welfare/${id}`);
  return response.data;
};

export const UpdateWelfare = async (data) => {
  const response = await Api.put('welfare/', data);
  return response.data;
};

export const DragAndDropWelfare = async (data) => {
  const response = await Api.post('welfare/changeOrder',data);
  return response.data;
};

export const DeleteWelfare = async (id) => {
  const response = await Api.delete(`welfare/${id}`);
  return response.data;
};


export const AddWelfareImages = async (data) => {
  const response = await Api.post("general/uploadFiles/", data);
  return response.data;
};